/* eslint-disable react/no-array-index-key */
import React, { useState }from 'react';
import { useSelector } from 'react-redux';
import {
  FiCreditCard,
  FiDollarSign,
  FiFileText,
  FiShare,
} from 'react-icons/fi';
import MaskedInput from 'react-text-mask';
import { toast } from 'react-toastify';
import isValidCPF from '../../../../support/utils/IsValidCPF';
import { ProcessButton, ProcessHeader } from '../../../components';

function usePaymentMethod(commands) {
  const [cpf, setCPF] = useState();
  const [showCPF, setShowCPF] = useState(false);

  const changeCPF = (e) => {
    const cleaned = (`${e.target.value}`).replace(/\D/g, '');
    setCPF(cleaned);
  };

  const setPaymentMethod = (method, userOrder, userCPF) => {
    if (method === 'billet' && userOrder && !userCPF) return setShowCPF(true);
    commands.order.changeDataAttribute('paymentMethod', method);
    commands.process.goToStep(6);
  };

  const registerBilletWithCPF = () => {
    if (!isValidCPF(cpf)) return toast('Número de CPF inválido', { type: toast.TYPE.WARNING });
    commands.user.updateData({ cpf });
    commands.order.changeDataAttribute('paymentMethod', 'billet');
    commands.process.goToStep(6);
  };

  const goBack = () => {
    if(showCPF) return setShowCPF(false);
    commands.process.previousStep();
  }

  return ({
    eventHandlers: {
      changeCPF,
      registerBilletWithCPF,
      setPaymentMethod,
      goBack
    },
    localStates: {
      cpf,
      showCPF,
    },
  });
}

export default function PaymenthMethod(props) {
  const { commands, sharedStates } = props;
  const { localStates, eventHandlers } = usePaymentMethod(commands);

  const ItemInfo = {
    cash: {
      icon: <FiDollarSign size={32} strokeWidth="0.8" />,
      title: 'Dinheiro',
      description: 'no dinheiro',
    },
    card: {
      icon: <FiCreditCard size={32} strokeWidth="0.8" />,
      title: 'Cartão',
      description: 'no cartão',
    },
    credit_card: {
      icon: <FiCreditCard size={32} strokeWidth="0.8" />,
      title: 'Cartão de crédito',
      description: 'no cartão de crédito',
    },
    debit_card: {
      icon: <FiCreditCard size={32} strokeWidth="0.8" />,
      title: 'Cartão de débito',
      description: 'no cartão de débito',
    },
    billet: {
      icon: <FiFileText size={32} strokeWidth="0.8" />,
      title: 'Boleto',
      description: 'no boleto',
    },
    bank_transfer: {
      icon: <FiShare size={32} strokeWidth="0.8" />,
      title: `${!sharedStates.space?.payment?.bankInfo?.every((bankInfo) => !bankInfo.pixKey) ? 'PIX /' : ''} Transferência bancária`,
      description: `via transferência bancária (${sharedStates.space?.payment?.bankInfo?.map((bankInfo) => bankInfo.bank).join(', ')})`,
    },
  };
  
  return (
    <section className="step-container">
      <ProcessHeader goBackAction={eventHandlers.goBack}/>
      <h1 className="step-title">{localStates.showCPF ? 'Insira seu CPF para registro do boleto': 'Qual a forma de pagamento?'}</h1>
      <div className="step-options-group">
        { !localStates.showCPF &&
          sharedStates.availableMethods.map((item, index) => (
            <button
              key={index}
              type="button"
              onClick={() => eventHandlers.setPaymentMethod(item, !sharedStates.consumerSpaceData, sharedStates.userCPF)}
              className={`step-option-button ${sharedStates.order.paymentMethod === item ? 'step-option-selected' : ''}`}
            >
              <div className="step-option-icon">
                {ItemInfo[item]?.icon}
              </div>

              <div className="step-option-text">
                <h2>{ItemInfo[item]?.title}</h2>
                <p>
                  {`Pague ${ItemInfo[item]?.description} `}
                  {(item === 'billet' || item === 'bank_transfer') ? 'antes ' : 'no momento '}
                  {sharedStates.order.deliveryMethod === 'home_delivery' ? 'da entrega' : 'de buscar'}
                </p>
              </div>
            </button>
          ))
        }
      </div>
      {
        localStates.showCPF
        && (
          <>
            <div className="floating-label-input">
              <MaskedInput
                value={localStates.cpf}
                onChange={eventHandlers.changeCPF}
                mask={[/[0-9]/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/]}
                placeholder="CPF"
                id="cpf"
                type="text"
                name="cpf"
              />
              {/* <input required placeholder="CPF" id="cpf" type="text" name="cpf" value={formatPhoneNumber(cpf)} onChange={(e) => setCPF(e.target.value)} /> */}
              <label htmlFor="cpf">CPF</label>
            </div>
            <ProcessButton action={eventHandlers.registerBilletWithCPF} />
          </>
        )
      }
    </section>
  );
}
